{
  "cancel": "Annuler",
  "save": "Enregistrer",
  "create": "Créer",
  "delete": "Supprimer",
  "edit": "Modifier",
  "close": "Fermer",
  "confirm": "Confirmer",
  "yes": "Oui",
  "no": "Non",
  "loading": "Chargement…",
  "error": "Erreur",
  "success": "Succès",
  "search": "Rechercher",
  "filter": "Filtrer",
  "refresh": "Actualiser",
  "back": "Retour",
  "language": "Langue",
  "english": "English",
  "french": "Français",
  "loading_module": "chargement du module…",
  "relative_time": {
    "just_now": "à l'instant",
    "seconds_ago": "il y a {{n}} s",
    "minutes_ago": "il y a {{n}} min",
    "hours_ago": "il y a {{n}} h"
  },
  "open_ip_view": "Ouvrir la vue IP {{ip}}"
}
